import type { FaireProductEntity } from "../../entity_types/product";

export const p_3p4rwt5em2: FaireProductEntity = {
  token: "p_3p4rwt5em2",
  type: "product",
  name: "Seasonal Cocktail Filled Spinner Display Package",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/0664cd15ea1f8e26485c7bd8061f99b9a01b21a265516dd104f8bc322ed0672c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/26990ba65d661864d2ae07bb6ff679ebcb1e881e323ccf0f047f54efd1c1c32d.jpeg",
    "https://cdn.faire.com/fastly/5ec412b2afcf3a6f18d208aaa13d353bac91ed6461c56b23c1a89011976db4ea.jpeg",
    "https://cdn.faire.com/fastly/cf6cd99500ed039f919e5ac1a1938b6b19052f361d12ea9fc55bdc9ba99b62b4.jpeg",
    "https://cdn.faire.com/fastly/341afa0207ce8494157d1b65478dee310c22411cb10918257333462b791ca41d.jpeg",
    "https://cdn.faire.com/fastly/9348f4534b69bded50131d0d5907105c1b3d9dd11cdfa5bd9c4e0917cb10b802.jpeg",
    "https://cdn.faire.com/fastly/c6fdcccd11a84b602ac9304c85982726d8ab8e765ea085df623169f7c32bfc4f.jpeg",
  ],
  priceDollars: 403.2,
  description:
    "Seasonal Cocktail Spinner Display Package - Incl: 48 Of Each Seasonal Cocktail Comes With FREE Display (total of 288) $1.40 each\n\nSeasonal Cocktail Spinner Display Package includes: 48 Hot Toddy, 48 Irish Coffee, 48 Pumpkin Spice Chai Martini, 48 S'mores Hot Cocoa, 48 Espresso Martini, 48 Old Fashioned and FREE Spinner Display.\n\nThe best way to get cocktails into customers hands!",
  tags: [],
  msrpDollars: 806.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:08:58.373Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
